import { RECIPES } from '../../data/recipes';
import type { Recipe } from '../../domain/recipe';

/**
 * DE: Eingebautes Rezept nach Kennung; eine unbekannte Kennung ist ein Datenfehler.
 * EN: Built-in recipe by id; an unknown id is a data error.
 */
export function recipeById(id: string): Recipe {
  const recipe = RECIPES.find((candidate) => candidate.id === id);
  if (!recipe) throw new Error(`Unknown recipe: ${id}`);
  return recipe;
}
